import React, { Component } from 'react';

import { Tag,Row, Col,Menu,Pagination,message,Breadcrumb,Icon ,Input, Select, Form, Tabs, Button, Table ,Tree,Checkbox,Tooltip} from 'antd';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import QuestionEvaluating from '../evaluating_detail_question/view';

import axios from 'axios';
import API from '../../../../API/api'


/** PERSONAL */
const { Option } = Select;
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
const TreeNode = Tree.TreeNode;

const EVALUATING_TASK_STAGE_MAP = {
    0 :'pre_assign',
    1 :'signing',
    2 :'pre_check',
    3 :'checking',
    4 :'check_pass',
    5 :'rework',
}
class MissionDetail extends Component{
    state = {
        name:'',
        chapter:'',
        clerk:'',
        total:1,
        listFilterNow:'0',
        page:1,
        pagesize:localStorage.getItem('questionlist_pagesize')||20,
        isVerify:false,
        task_id:'',
        list:[],
        stage:'',

        clickfold:false,
        expandedKeys:[],
        selectedKeys:[],
        question_list:[],

        is_base:true,
        is_calculation:true,

    }
    listFilter =(val)=>{//筛选改变
        let {listFilterNow} = this.state
        if(listFilterNow===val.key) return
        this.setState({listFilterNow:val.key,page:1})
        setTimeout(()=>{
            this.getQuestionList()
        },0)
    }
    onPageChange =(val)=>{//翻页
        this.setState({page:val})
        setTimeout(()=>{
            this.getQuestionList()
            document.querySelector('.questionListScroll').scrollTop=0
        },0)
    }

    getQuestionList=()=>{
        if(!this.state.selectedKeys[0]){
            return message.error('请选择章节树节点')
        }
        let {listFilterNow,page,pagesize} = this.state
        let task_id = window.location.href.split('/').pop()
        let data = {
            is_calculation:~~this.state.is_calculation,
            is_base:~~this.state.is_base,
            task_id:task_id,
            tree_id:this.state.selectedKeys[0],
            page:page,
            pagesize:pagesize,
            // tab:this.state.listFilterNow
            tab_type:this.state.listFilterNow
        }
            axios.post(API.EVALUATION_TASK_QUESTION_LIST,data).then((res)=>{
                res = res.data
                if (res.code === 0) {
                    // this.setState({textClerkList:res.data.list})
                    let {page,pagesize,total,tree_update} = res.data
                    let list = res.data.question_list
                    list.forEach((item)=>{//评测题列表不显示解析
                        item.explain = ''
                    })
                    this.setState({task_id,page,pagesize,total,list,tree_update})
                    this.changeTreeOneLine(this.state.selectedKeys[0],res.data.tree_update)


                }else{
                    message.error(res.message)
                }
            },()=>{message.error("网络错误！")})
    }


    refresh=()=>{
        this.getQuestionList()
    }
    componentDidMount(){
        axios.post(API.EVALUATION_TASK_INFO,{task_id:window.location.href.split('/').pop()}).then((res)=>{
            res = res.data
            if (res.code === 0) {
                // let listFilterNow = this.state.listFilterNow
                // if(EVALUATING_TASK_STAGE_MAP[res.data.stage]=='signing'){
                //     listFilterNow = '1'
                // }
                // if(EVALUATING_TASK_STAGE_MAP[res.data.stage]=='rework'){
                //     listFilterNow = '5'
                // }
                this.setState({
                    name:res.data.name,
                    clerk:res.data.entry_user,
                    chapter:res.data.name_ext,
                    isVerify:this.state.isVerify,
                    stage:EVALUATING_TASK_STAGE_MAP[res.data.stage],
                    // listFilterNow,
                })
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    componentWillMount() {
        this.getTreeData()
    }

    shouldComponentUpdate(nextProps,nextState){
        if(
            nextState.treeData&&(nextState.treeData!==this.state.treeData)//树结构改变
        ){
            this.treeNode=this.loop(nextState.treeData,nextState)
        }
        return true;
    }
    componentDidUpdate(prevProps, prevState) {
        this.watchChange(this.state.selectedKeys,prevState.selectedKeys,()=>{this.getQuestionList()})//树节点变化时id list改变
    }
    watchChange = (val,newVal,fn,data)=>{
        if(val!==newVal){
            fn(data)
        }
    }
    getTreeData = ()=>{
        let task_id = window.location.href.split('/').pop()
        let data = {
            task_id:task_id
        }
        axios.post(API.EVALUATION_TASK_LIST_TREE,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({treeData:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }


    pageChange=(val)=>{
        this.setState({page:val})
        setTimeout(()=>{
            this.getQuestionList(this.state.page)
            document.querySelector('.questionListScroll').scrollTop=0
        },0)
    }

    changeTreeOneLine=(tree_id,tree_update)=>{
        const loop = (data, key, callback) => {
            data.forEach((item, index, arr) => {
                if (item.id === key) {
                    return callback(item, index, arr);
                }
                if (item.list) {
                    return loop(item.list, key, callback);
                }
            });
        };
        loop(this.state.treeData, tree_id, (item, index, arr) => {
            item = Object.assign(item,tree_update)

        });
        this.setState({treeData:[...this.state.treeData]})
    }

    treeNode=[]

//树结构的loop方法
    loop = (data,nextState) => {
        return data.map((item) => {
            this.state.expandedKeys.push(item.id)
            return <TreeNode selectable={item.question_count>0} title={item.question_count>0?<span style={{fontSize:15}}>
                    <Tooltip title={item.name} mouseEnterDelay={1}>
                        {item.name.slice(0,11)}
                    </Tooltip>
                    ({item.question_base_count}/{item.question_calculation_count})
                    <span style={{fontSize:15,color:'#999',marginLeft:5,fontWeight:'600'}}>
                                                评测题：
                                                <span style={{color:'#0d84c3'}}>
                                                    （{item.question_base_count_evaluation}/{item.question_calculation_count_evaluation}）
                                                </span>
                                            </span>
                                            <span style={{fontSize:15,color:'#999',marginLeft:5,fontWeight:'600'}}>
                                                课后题：
                                                <span style={{color:'#0d84c3'}}>
                                                    ({item.question_base_count_afterclass}/{item.question_calculation_count_afterclass})
                                                </span>
                                            </span>
                                            <span style={{fontSize:15,color:'#999',marginLeft:5,fontWeight:'600'}}>
                                                扩展题：
                                                <span style={{color:'#0d84c3'}}>
                                                    ({item.question_base_count_extend}/{item.question_calculation_count_extend})
                                                </span>
                                            </span>
                                        </span>
                :
                <span style={{fontSize:15}}>{item.name}</span>
            }
                             key={item.id}
            >
                {
                    item.list && item.list.length&&
                    this.loop(item.list,nextState)
                }
            </TreeNode>;
        });
    }

    //关掉多层（因设置expandedKeys后无法自动关掉多层）
    onTreeExpand=(expandedKeys,obj)=>{
        let expandedKeysSet = new Set(expandedKeys)
        if(!obj.expanded){
            const loop = (data, key, callback) => {
                data.forEach((item, index, arr) => {
                    if (item.id === key) {
                        return callback(item, index, arr);
                    }
                    if (item.list) {
                        return loop(item.list, key, callback);
                    }
                });
            };
            //所有节点执行cb的loop
            const loopAll = (data, callback) => {
                data.forEach((item, index, arr) => {
                    callback(item, index, arr);
                    if(item.list) {
                        return loopAll(item.list, callback);
                    }
                });
            };
            loop(this.state.treeData, obj.node.props.eventKey, (item, index, arr) => {
                //目标节点下的所有节点从expandedKeys中移除
                item.list&&loopAll(item.list,(item1)=>{
                    expandedKeysSet.delete(item1.id)
                })
            });
        }
        this.setState({expandedKeys:[...expandedKeysSet],})

    }
    onSelect = (selectedKeys, info) => {

        if(selectedKeys.length){
            this.setState({selectedKeys:selectedKeys})
        }

    }
    onShowSizeChange = (current, pagesize) => {
        this.setState({pagesize})
        setTimeout(()=>{
            this.getQuestionList()
        },0)

    }
    changeCount = (str,val)=>{

        this.state.tree_update[str] = ~~val + ~~this.state.tree_update[str]
        this.changeTreeOneLine(this.state.selectedKeys[0],this.state.tree_update)
        this.forceUpdate()
    }
    render() {
        const {subject, role_evaluation} = this.props
        return(
            <div style={{fontSize:'14px',position:'relative'}}>
                <Breadcrumb>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>评测&精题任务</span>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item style={{fontSize:20}}>
                        <span>任务详情</span>
                        <span>（&nbsp;{window.location.href.split('/').pop()}&nbsp;）</span>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{marginTop:15}}>
                    <Col span={20}>
                        <div style={{width:'100%',borderRadius:4,border:'solid 1px #999999',padding:'8px 15px'}}>
                            {this.state.name && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.name}</Tag>}
                            {this.state.chapter && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>{this.state.chapter}</Tag>}
                            {/*{this.state.clerk && <Tag color="#108ee9" style={{fontSize:14,margin:'3px 5px'}}>录入员：{this.state.clerk}</Tag>}*/}
                        </div>
                    </Col>

                </Row>
                <Row style={{marginTop:15}}>
                    <Row>
                        <div>
                            <div style={{width:'calc(58.3%)',position:'absolute',paddingRight:20,minHeight:'300px',height: '100%',}}>
                                <div style={
                                    {background:'#fff',zIndex:19,position:'absolute', height: '100%', left: 0, top: 0, width:'calc(100% - 18px)', transform: this.state.clickfold?'translateX(-105%)':'translateX(0)', transition: 'all 1s'}
                                }>
                                    {/*拉开收起按钮*/}
                                    {

                                        <div style={{borderRadius:3,background:'red',color:'#fff',position:'absolute',width:'18px',top:'150px',right:'-18px',transform: 'translateY(-50%)',padding:'2px',cursor:'pointer'}}
                                             onClick={()=>{this.setState({clickfold:!this.state.clickfold})}}>
                                            {this.state.clickfold?'点击展开任务信息':'点击收起'}
                                        </div>
                                    }
                                    <div style={{    background: '#fff'}}>
                                        <Tree
                                            defaultExpandAll={true}
                                            showLine
                                            expandedKeys={this.state.expandedKeys}
                                            selectedKeys={this.state.selectedKeys}
                                            onSelect={this.onSelect}
                                            showIcon={false}
                                            onExpand={this.onTreeExpand}
                                        >
                                            {/*{this.treeNode.map(d=>d)}*/}
                                            {/*更新卡顿*/}
                                            {this.state.treeData&&this.loop(this.state.treeData)}
                                        </Tree>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Row>
                </Row>
                <Row style={{marginTop:15}}>
                    <div style={{fontSize:12}}>
                        <span>题目种类：</span>
                        <Checkbox style={{marginLeft:20}} checked = { this.state.is_base } onChange = { (e)=>{this.setState({is_base:e.target.checked});setTimeout(()=>{this.getQuestionList()},0)} }>基础题</Checkbox>
                        <Checkbox style={{marginLeft:20}} checked = { this.state.is_calculation } onChange = { (e)=>{this.setState({is_calculation:e.target.checked});setTimeout(()=>{this.getQuestionList()},0)} }>计算题</Checkbox>

                    </div>
                </Row>
                <Row style={{marginTop:15}}>
                    <div style={{fontSize:12}}>

                        <Menu
                            selectedKeys={[this.state.listFilterNow]}
                            onClick={(e)=>{this.listFilter(e)}}
                            mode="horizontal"
                            style={{backgroundColor:'#f5f6fa'}}
                        >

                            <Menu.Item key={'0'}>全部
                                ({
                                this.state.tree_update&&
                                (
                                   this.state.is_base?
                                       ~~this.state.tree_update.question_base_count
                                        :0
                                )+(
                                    this.state.is_calculation?
                                        ~~this.state.tree_update.question_calculation_count
                                        :
                                        0
                                )
                            })
                            </Menu.Item>
                            <Menu.Item key={'1'}>普通题
                                ({
                                    this.state.tree_update&&
                                    (
                                        this.state.is_base?
                                            ~~this.state.tree_update.question_base_count_normal
                                            :0
                                    )+(
                                        this.state.is_calculation?
                                            ~~this.state.tree_update.question_calculation_count_normal
                                            :
                                            0
                                    )
                                })

                            </Menu.Item>
                            <Menu.Item key={'2'}>课后题
                                ({
                                    this.state.tree_update&&
                                    (
                                        this.state.is_base?
                                            ~~this.state.tree_update.question_base_count_afterclass
                                            :0
                                    )+(
                                        this.state.is_calculation?
                                            ~~this.state.tree_update.question_calculation_count_afterclass
                                            :
                                            0
                                    )
                                })
                            </Menu.Item>
                            <Menu.Item key={'3'}>扩展题
                                ({
                                    this.state.tree_update&&
                                    (
                                        this.state.is_base?
                                            ~~this.state.tree_update.question_base_count_extend
                                            :0
                                    )+(
                                        this.state.is_calculation?
                                            ~~this.state.tree_update.question_calculation_count_extend
                                            :
                                            0
                                    )
                                })
                            </Menu.Item>
                            <Menu.Item key={'4'}>评测题
                                ({
                                    this.state.tree_update&&
                                    (
                                        this.state.is_base?
                                            ~~this.state.tree_update.question_base_count_evaluation
                                            :0
                                    )+(
                                        this.state.is_calculation?
                                            ~~this.state.tree_update.question_calculation_count_evaluation
                                            :
                                            0
                                    )
                                })
                            </Menu.Item>

                        </Menu>

                            {/*{ //标记阶段*/}

                                {/*this.state.stage==='signing'&&*/}
                                {/*<Menu*/}
                                    {/*selectedKeys={[this.state.listFilterNow]}*/}
                                    {/*onClick={(e)=>{this.listFilter(e)}}*/}
                                    {/*mode="horizontal"*/}
                                    {/*style={{backgroundColor:'#f5f6fa'}}*/}
                                {/*>*/}
                                    {/*<Menu.Item key={'1'}>未完成</Menu.Item>*/}
                                    {/*<Menu.Item key={'2'}>已完成</Menu.Item>*/}

                                {/*</Menu>*/}
                            {/*}*/}
                            {/*{ //审核*/}
                                {/*this.state.stage==='checking'&&*/}
                                {/*<Menu*/}
                                    {/*selectedKeys={[this.state.listFilterNow]}*/}
                                    {/*onClick={(e)=>{this.listFilter(e)}}*/}
                                    {/*mode="horizontal"*/}
                                    {/*style={{backgroundColor:'#f5f6fa'}}*/}
                                {/*>*/}
                                    {/*<Menu.Item key={'0'}>全部</Menu.Item>*/}
                                    {/*<Menu.Item key={'3'}>未审核</Menu.Item>*/}
                                    {/*<Menu.Item key={'4'}>审核通过</Menu.Item>*/}
                                    {/*<Menu.Item key={'5'}>返工</Menu.Item>*/}
                                {/*</Menu>*/}
                            {/*}*/}
                            {/*{ //返工*/}
                                {/*this.state.stage==='rework'&&*/}
                                {/*<Menu*/}
                                    {/*selectedKeys={[this.state.listFilterNow]}*/}
                                    {/*onClick={(e)=>{this.listFilter(e)}}*/}
                                    {/*mode="horizontal"*/}
                                    {/*style={{backgroundColor:'#f5f6fa'}}*/}
                                {/*>*/}
                                    {/*<Menu.Item key={'5'}>返工</Menu.Item>*/}
                                    {/*<Menu.Item key={'4'}>审核通过</Menu.Item>*/}
                                    {/*<Menu.Item key={'2'}>完成</Menu.Item>*/}
                                {/*</Menu>*/}
                            {/*}*/}
                        {/*{*/}
                            {/*this.state.stage!=='signing'&&*/}
                            {/*this.state.stage!=='checking'&&*/}
                            {/*this.state.stage!=='rework'&&*/}
                            {/*<Menu*/}
                                {/*selectedKeys={[this.state.listFilterNow]}*/}
                                {/*onClick={(e)=>{this.listFilter(e)}}*/}
                                {/*mode="horizontal"*/}
                                {/*style={{backgroundColor:'#f5f6fa'}}*/}
                            {/*>*/}
                                {/*<Menu.Item key={'0'}>全部</Menu.Item>*/}

                            {/*</Menu>*/}
                        {/*}*/}
                    </div>
                </Row>
                <Row style={{height:"100%",position:'relative',zIndex:2}} className={'questionList explain-detail'}>
                    {
                        !!this.state.list.length ?
                            this.state.list.map((v,k)=>
                                <QuestionEvaluating 
                                    key = {k}
                                    role_evaluation={role_evaluation}
                                    stage={this.state.stage}
                                    subject={subject}
                                    taskId={this.state.task_id}
                                    tree_id={this.state.selectedKeys[0]}
                                    page={this.state.page}
                                    data={v}
                                    refresh={()=>{this.refresh()}}
                                    k={k}
                                    tab={this.state.listFilterNow}
                                    changeCount={this.changeCount}
                                    pagesize={this.state.pagesize}
                                />
                            )
                            :

                            <div style={{fontSize: "16px", height: "30px", marginBottom: "50px"}}>
                                <p style={{paddingTop: 15, paddingLeft: 50, color: 'green'}}>暂无题目</p>
                            </div>
                    }

                </Row>
                {
                    this.state.total>0 &&
                    <Row style={{marginTop:15,marginBottom:20,textAlign:'right'}}>
                        <Pagination showSizeChanger
                                    showQuickJumper
                                    onShowSizeChange={this.onShowSizeChange}
                                    pageSizeOptions={['30','50']}
                                    current={this.state.page}
                                    pageSize={this.state.pagesize}
                                    total={this.state.total}
                                    onChange={ this.onPageChange }/>
                    </Row>
                }
            </div>

        );
    }
}

const mapStateTopProps = (state) => {
    return {
        user:state.user,
        role_evaluation:state.user.role_evaluation,
        subject:state.user.subject,
    };
}
const mapDispatchToProps = dispatch => {
    return {
    }
};
export default connect(mapStateTopProps,mapDispatchToProps)(MissionDetail)




// WEBPACK FOOTER //
// ./src/entry_app/question_manage/question_evaluating/evaluating_detail/view.js